import React, { FC, useState, useCallback, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
// import { useHistory, useLocation } from 'react-router-dom';
import { Content, PageHeader, ButtonWithLoading, useNotification, Button, ButtonWithIcon, Label, SelectField, Icon, SmallInput, AlertBar, FilterButton } from 'scorer-ui-kit';
import styled from 'styled-components';
import { saveSchedule, getSchedules, removeSchedule } from 'services/apiConfig';
import BoxModal from 'components/BoxModal';
import { Divider } from 'Styles';
import { TimePicker, DatePicker } from 'antd';
import dayjs from 'dayjs';
// import type { DatePickerProps } from 'antd';

const MainContent = styled.div`
  margin-top: -5px;
  max-width: 940px !important;
`;

const Header = styled.div`
  width: 100%;
  max-width: 940px !important;
  height: 108px;
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  position: relative;
  line-height: 1.2;
  > div:first-child > div > a {
    max-width: 750px;
    overflow-wrap: break-word;
    white-space: break-spaces;
    bottom: 34.5px;
    top: unset;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
`;

const PageHeaderComponent = styled.div`
  display: flex;
  flex-direction: column;
`;

const ButtonContainer = styled.div`
  margin-top: -14px;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  justify-content: flex-start;
  gap: 10px 0;
  & > button {
    min-width: 155px;
  }
`;


const ScheduleContainer = styled.div`
  margin-top: 45px;
  margin-bottom: 25px;
`;

const ListButtonContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  row-gap: 20px;
  gap: 20px;
  & > button {
    background: #e4edf4;
    :hover:enabled {
      background: #d4e4f0;
    }
    :disabled {
      background: #e9f0f6;
    }
  }
  margin-top: 40px;
`;


const TwoButtonContainer = styled.div<{ gap: string }>`
  display: flex;
  gap: ${({ gap }) => gap};
`;


const FlexContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-bottom: 10px;
`;

const SubTitle = styled.label`
  font-size: 16px;
  font-weight: 500;
  font-family: ${({ theme }) => theme.fontFamily.ui};
  color: #5a6269;
  margin: 0;
  padding: 0;
`;

const AddContainer = styled.div`
  margin-left: 80px;
  & > button {
    background: #e4edf4;
    :hover:enabled {
      background: #d4e4f0;
    }
    :disabled {
      background: #e9f0f6;
    }
  }
`;

const AddBox = styled.div`
  width: 500px;
  padding: 25px;
  background-color: #F3F6F7;
`;

const AddButtonBox = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-top: 30px;
  & > button:first-child{
    margin-right: 10px;
  }
`;

const AddText = styled(Label)`
  font-size: 20px;
`;

const ButtonFormat = styled(Button)`
  &:focus {
    outline: 2px solid #838383;
  }
`;


const ButtonX = styled(Button)`
  height: 30px;
  padding: 0 9px;
`;

const SelectBox = styled.div`
  width: 200px;
`;

const LineSettingsContainer = styled.div`
  width: 100%;
  max-width: 940px !important;
  margin: 20px 0;
`;

const LineSelectFieldContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 0 10px;
  position: relative;
  & > div:first-child {
    position: absolute;
    top: 6px;
    left: -24px;
  }
`;

const StyledSelectField = styled(SelectField)`
  width: 209px;
  background: #fff;
  &:disabled {
    opacity: 0.7;
  }
  & + div {
    top: 50% !important;
    transform: translateY(-50%) !important;
  }
`;

const LineUIContainer = styled.div`
  width: 100%;
  max-width: 940px !important;
  display: flex;
  margin: 30px 0 15px;
  position: relative;
  border-radius: 3px;
  background-color: #fafcfc;
  box-shadow: 0 4px 9px 0 rgba(152, 174, 189, 0.05);
  border: solid 1px #eee;
  flex-direction: column;
  &::before {
    content: "";
    width: 14.5px;
    height: 51px;
    position: absolute;
    top: -26px;
    left: -16px;
    border-left: 1px solid #d9dad9;
    border-bottom: 1px solid #d9dad9;
  }
`;

const InputAndButtonContainer = styled.div<{ gap: string }>`
  font-size: 14px;
  display: flex;
  align-items: center;
  gap: ${({ gap }) => gap};
  & > button {
    background: #e4edf4;
    :hover:enabled {
      background: #d4e4f0;
    }
    :disabled {
      background: #e9f0f6;
    }
  }
`;

const InnerContainer = styled.div`
  padding: 15px;
`;

const DividerWithMargin = styled(Divider)`
  margin: 14px 0 12px;
`;


const StyledSmallInputWithLabel = styled(SmallInput)`
  & > label {
    width: 210px;
    margin-bottom: 0;
    font-size: 12px;
  }
`;

const AlertContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 5px;
`;



const ScheduleConfig: FC = () => {
  const { t } = useTranslation(['CommonDict']);
  const [saveLoading, setSaveLoading] = useState<boolean>(false);
  const [isReadOnly, setIsReadOnly] = useState<boolean>(false);
  const { sendNotification } = useNotification();
  const [scheduleData, setScheduleData] = useState<any>([]);
  const [openWindowModal, setOpenWindowModal] = useState<boolean>(false);
  const [dayOfWeek] = useState(['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday']);
  const [tmpOpenWindow, setTmpOpenWindow] = useState({day_of_week: '', start_time: '00:00:00', end_time: '00:00:00'});
  const [tmpException, setTmpException] = useState({date: '', start_time: '00:00:00', end_time: '00:00:00'});
  const [timeFormat] = useState('HH:mm');
  const [dateFormat] = useState('MM-DD');
  const [modalType, setModalType] = useState('');
  const [selectedButtonId, setSelectedButtonId] = useState('');
  const [selectedScheduleId, setSelectedScheduleId] = React.useState('');
  const [defaultScheduleName, setDefaultScheduleName] = useState(''); 
  const [defaultFrequency, setDefaultFrequency] = useState(0); 
  const [errorMessage, setErrorMessage] = useState(''); 

  //Get Schedule Data
  const onGetSchedule = useCallback(async () => {
    try {
      const response = await getSchedules();
      if(response.status === 200) {
        setScheduleData(response.data.data);
      }
    }
    catch {
      sendNotification({ type: 'error', message: 'Failed to get schedules.' });
    }
  }, [sendNotification]);
  useEffect(() => {
    onGetSchedule();
  }, [onGetSchedule]);

  

  // Add And Remove Schedule

  function generateNewId(schedule_data:any){
    const arr = schedule_data.map((a:any) => a.id);
    const n = Math.max.apply(null, arr);  // get the maximum
    const missingNumbers = [];
    for (let i=1 ; i<n ; i++) {
      if (arr.indexOf(i) < 0) {
        missingNumbers.push(i);
      }
    }
    if(missingNumbers.length > 0){
      return missingNumbers[0];
    } else {
      return Math.max(...arr) + 1;
    }
  }

  const addSchedule = useCallback(async () => {
    const newId = generateNewId(scheduleData);
    const defaultNewAreaName = `new_schedule_${newId}`;
  
    const newScheduleData = JSON.parse(JSON.stringify(scheduleData));
    newScheduleData.push({id: newId, name: defaultNewAreaName, schedule: {open_time_window: [], open_day: []}, frequency: 0});
    setSelectedScheduleId((newScheduleData.length - 1).toString());
    setScheduleData(newScheduleData);
    setDefaultScheduleName(defaultNewAreaName);
    setDefaultFrequency(0);
  }, [scheduleData]);

  const removeSchedules = useCallback(async () => {
    const scheduleId = scheduleData[Number(selectedScheduleId)].id;
    try {
      const response = await removeSchedule({'scheduleId': scheduleId});
      if(response.status === 200) {
        setSelectedScheduleId('');
        sendNotification({ type: 'success', message: t('Removed schedule successfully.') });
      } else {
        sendNotification({ type: 'error', message: t('Failed to remove schedule.') });
      }
    } catch (error) {
      console.error(error);
      sendNotification({ type: 'error', message: t('Failed to remove schedule.') });
    }
  }, [selectedScheduleId, scheduleData, sendNotification, t]);

  // Add And Remove Schedule

  // Edit Schedule Name
  const editScheduleName = (e: any) => {
    const index = Number(selectedScheduleId);
    const newScheduleName = e.target.value;
    setDefaultScheduleName(newScheduleName);


    const newScheduleData = JSON.parse(JSON.stringify(scheduleData));
    newScheduleData[index].name = newScheduleName;
    setScheduleData(newScheduleData);
  };

  // Edit Schedule Freq
  const editFrequency = (e: any) => {
    const index = Number(selectedScheduleId);
    const newFreq = e.target.value;
    if(Number(newFreq) >= 0 && Number(newFreq) <= 1440){
      setDefaultFrequency(Number(newFreq));
      const newScheduleData = JSON.parse(JSON.stringify(scheduleData));
      newScheduleData[index].frequency = Number(newFreq);
      setScheduleData(newScheduleData);
    } else {
      setErrorMessage('Please set the VQA schedule frequency in the range of 0 and 1440.');
    }
    
  };
  
  //Open Window 
  const handleAddOpenWindow = useCallback(() => {
    setModalType('addOpenWindow');
    setOpenWindowModal(true);
  }, []);

  const handleTmpOpenWindow = useCallback((e, type) => {
    const copiedTmpOpenWindow = {...tmpOpenWindow};
    if(type === 'day'){
      copiedTmpOpenWindow.day_of_week = e;
    } else if(type === 'time'){
      copiedTmpOpenWindow.start_time = `${dayjs(e[0].$d).format(timeFormat)}:00`;
      copiedTmpOpenWindow.end_time = `${dayjs(e[1].$d).format(timeFormat)}:59`;
    }
    setTmpOpenWindow(copiedTmpOpenWindow);
  }, [tmpOpenWindow, timeFormat]);


  const handleChangeOW = useCallback((type) => {
    if(tmpOpenWindow.day_of_week && tmpOpenWindow.start_time && tmpOpenWindow.end_time){
      const copiedSchedule = [...scheduleData];
      if(type==='addOpenWindow'){
        copiedSchedule[Number(selectedScheduleId)].schedule.open_time_window.push(tmpOpenWindow);
      } else if(type==='editOpenWindow') {
        copiedSchedule[Number(selectedScheduleId)].schedule.open_time_window[Number(selectedButtonId)] = tmpOpenWindow;
      }
      setScheduleData(copiedSchedule);
      setTmpOpenWindow({day_of_week: '', start_time: '00:00:00', end_time: '00:00:00'});
    } else{
      setErrorMessage('Please enter values correctly.' );
    }
    setOpenWindowModal(false);
  }, [tmpOpenWindow, scheduleData, selectedButtonId, selectedScheduleId]);

  


  const handleEditOpenWindow = useCallback((e) => {
    setSelectedButtonId(e);
    const copiedSchedule = [...scheduleData];
    setTmpOpenWindow(copiedSchedule[Number(selectedScheduleId)].schedule.open_time_window[Number(e)]);
    setModalType('editOpenWindow');
    setOpenWindowModal(true);
  }, [scheduleData, selectedScheduleId]);

  const handleCancelButton = useCallback((type) => {
    if(type === 'openWindow'){
      setTmpOpenWindow({day_of_week: '', start_time: '00:00:00', end_time: '00:00:00'});
      
    } else {
      setTmpException({date: '', start_time: '00:00:00', end_time: '00:00:00'});
      // setExceptionModal(false);
    }
    setOpenWindowModal(false);
    
  }, []);

  const handleRemoveOpenWindow = useCallback((e) => {
    const copiedSchedule = [...scheduleData];
    copiedSchedule[Number(selectedScheduleId)].schedule.open_time_window.splice(e, 1);
    setScheduleData(copiedSchedule);
  }, [scheduleData, selectedScheduleId]);

  //Open Window 

  // Shcedule Exception

  const handleAddException = useCallback(() => {
    setModalType('addException');
    // setExceptionModal(true);
    setOpenWindowModal(true);
  }, []);

  const handleTmpException = useCallback((e, type) => {
    const copiedTmpException = {...tmpException};
    if(type === 'day'){
      copiedTmpException.date = dayjs(e).format('MMDD');
    } else if(type === 'time'){
      copiedTmpException.start_time = `${dayjs(e[0].$d).format(timeFormat)}:00`;
      copiedTmpException.end_time = `${dayjs(e[1].$d).format(timeFormat)}:59`;
    }
    setTmpException(copiedTmpException);
  }, [tmpException, timeFormat]);


  const handleEditException = useCallback((e) => {
    setSelectedButtonId(e);
    const copiedSchedule = [...scheduleData];
    setTmpException(copiedSchedule[Number(selectedScheduleId)].schedule.open_day[Number(e)]);
    setModalType('editException');
    setOpenWindowModal(true);
  }, [scheduleData, selectedScheduleId]);

  const handleRemoveException = useCallback((e) => {
    const copiedSchedule = [...scheduleData];
    copiedSchedule[Number(selectedScheduleId)].schedule.open_day.splice(e, 1);
    setScheduleData(copiedSchedule);
  }, [scheduleData, selectedScheduleId]);

  const handleChangeException = useCallback((type) => {
    if(tmpException.date && tmpException.start_time && tmpException.end_time){
      const copiedSchedule = [...scheduleData];
      if(type==='addException') {
        copiedSchedule[Number(selectedScheduleId)].schedule.open_day.push(tmpException);
      } else if(type==='editException') {
        copiedSchedule[Number(selectedScheduleId)].schedule.open_day[Number(selectedButtonId)] = tmpException;
      } 
      setScheduleData(copiedSchedule);
      setTmpException({date: '', start_time: '00:00:00', end_time: '00:00:00'});
    } else{
      setErrorMessage('Please enter values correctly.' );
    }
    setOpenWindowModal(false);
  }, [tmpException, scheduleData, selectedButtonId, selectedScheduleId]);




  //Save Schedule
  const saveSchedules = useCallback(async () => {
    for (let i = 0; i < scheduleData.length; i++) {
      if (scheduleData[i].name === '' || scheduleData[i].name == null) {
        sendNotification({ type: 'error', message: t('Schedule name cannot be empty.') });
        return;
      }
    }
    
    setSaveLoading(true);
    setIsReadOnly(true);


    try {
      const response = await saveSchedule({'scheduleData': scheduleData});
      if (response.data.status_code !== 200) {
        sendNotification({ type: 'error', message: response.data.message });
      }else{
        if(response.status === 200) {
          sendNotification({ type: 'success', message: t('Saved schedule successfully.') });
        } else {
          sendNotification({ type: 'error', message: t('Failed to save schedule.') });
        }
      }
    } catch (error) {
      console.error(error);
      sendNotification({ type: 'error', message: t('Failed to save schedule.') });
    }
    setSaveLoading(false);
    setIsReadOnly(false);
  }, [scheduleData, sendNotification, t]);

  function hideSeconds(time_val:any) {
    return time_val.substring(0, time_val.lastIndexOf(':'));
  }

  

  return (
    <Content>
      <Header>
        <PageHeaderComponent>
          <PageHeader
            areaTitle={t('Configuration')}
            icon='DateTime'
            updateDocTitle={false}
            title={t('VQAスケジュール')}
          />
        </PageHeaderComponent>
        <ButtonContainer>
          <ButtonWithLoading design='primary' loading={saveLoading} disabled={selectedScheduleId === ''} size='small' onClick={saveSchedules}>
            {t('Save Changes')}
          </ButtonWithLoading>
        </ButtonContainer>
      </Header>
      <MainContent>
        <AlertContainer>
          {errorMessage && 
            <AlertBar
              message={t(errorMessage)}
              type='error'
            />}
        </AlertContainer>
        <LineSettingsContainer>
          <h5>{t('Schedule Configuration')}</h5>
          <LineSelectFieldContainer>
            <Icon icon='DataRetention' size={16} color='dimmed' />
            <StyledSelectField
              changeCallback={(e)=>setSelectedScheduleId(e)}
              disabled={isReadOnly}
              isCompact
              value={selectedScheduleId ? Number(selectedScheduleId) : ''}
              placeholder={t('Choose a schedule')}
            >
              {
                scheduleData.map((item: any, index: any) => {
                  return (
                    <option key={index} value={index}>
                      {item.name}
                    </option>
                  );
                })
              }
            </StyledSelectField>
            <InputAndButtonContainer gap='0 10px'>
              <ButtonWithIcon
                icon='Add'
                position='left'
                size='small'
                design='secondary'
                onClick={addSchedule}
                disabled={scheduleData.length === 20 ||isReadOnly}
              >
                {t('Add Schedule')}
              </ButtonWithIcon>
              <ButtonWithIcon
                icon='ActionRemove'
                position='left'
                size='small'
                design='secondary'
                onClick={removeSchedules}
                disabled={selectedScheduleId === '' || scheduleData.length === 0 || isReadOnly}
              >
                {t('Remove Schedule')}
              </ButtonWithIcon>
            </InputAndButtonContainer>
          </LineSelectFieldContainer>
          {(selectedScheduleId !== '') && (
            <LineUIContainer>
              <InnerContainer>
                <TwoButtonContainer gap='0 20px'>
                  <StyledSmallInputWithLabel
                    fieldState='default'
                    label={t('Schedule Name')}
                    name='Schedule Name'
                    maxLength={24}
                    disabled={isReadOnly}
                    value={selectedScheduleId ? scheduleData[Number(selectedScheduleId)].name : defaultScheduleName}
                    onChange={(e) => editScheduleName(e)}
                  />
                  <StyledSmallInputWithLabel
                    fieldState='default'
                    label={t('Frequency')}
                    name='frequency'
                    maxLength={24}
                    disabled={isReadOnly}
                    value={selectedScheduleId  ? scheduleData[Number(selectedScheduleId)].frequency : defaultFrequency}
                    unit={t('minutes')}
                    type='number'
                    onChange={(e) => editFrequency(e)}
                  />
                </TwoButtonContainer>
                
                <DividerWithMargin />
                <ScheduleContainer>
                  <FlexContainer>
                    <SubTitle>{t('Open Time Window')}</SubTitle>
                    <AddContainer>
                      <ButtonWithIcon
                        icon='Add'
                        position='right'
                        size='small'
                        design='secondary'
                        onClick={handleAddOpenWindow}
                        disabled={isReadOnly}
                      >
                        {t('Add Open Time Window')}
                      </ButtonWithIcon>
                    </AddContainer>
                    
                    
                  </FlexContainer>
                  <ListButtonContainer>
                    {selectedScheduleId ? scheduleData[Number(selectedScheduleId)].schedule.open_time_window.map((item: any, index: any) => {
                      return (
                        <TwoButtonContainer key={index} gap='0 2px'>
                          <FilterButton icon='MetaTags' onClick={() => handleEditOpenWindow(index)}>
                            {t(item.day_of_week)} {hideSeconds(item.start_time)} ~ {hideSeconds(item.end_time)}
                          </FilterButton>
                          <ButtonX design='danger' disabled={isReadOnly} onClick={()=> handleRemoveOpenWindow(index)}>
                            X
                          </ButtonX>
                        </TwoButtonContainer>
                      );
                    }): ''}
                  </ListButtonContainer>
                </ScheduleContainer>
                {openWindowModal &&
                  <BoxModal
                    closeText={t('CLOSE')}
                    isOpen={openWindowModal}
                    onDismiss={()=>{}}
                    isCloseEnable={false}
                    customeComponent={
                      <AddBox>
                        {(modalType==='addOpenWindow') && (
                          <>
                            <AddText htmlFor='' labelText={t('Add Open Time Window')} />
                            <SelectBox>
                              <SelectField
                                changeCallback={(e)=>handleTmpOpenWindow(e, 'day')}
                                label={{
                                  htmlFor: 'free_select',
                                  text: t('Day Of The Week')
                                }}
                                placeholder={t('Choose an option...')}
                              >
                                {dayOfWeek.map((item: any, index: any) => {
                                  return (
                                    <option value={item} key={index}>
                                      {t(item)}
                                    </option>
                                  );
                                })}
                                
                              </SelectField>
                            </SelectBox>
                            <TimePicker.RangePicker
                              onPickerValueChange={(e)=> handleTmpOpenWindow(e, 'time')}
                              format={timeFormat}
                              needConfirm={false}
                              value={[dayjs(tmpOpenWindow.start_time, timeFormat), dayjs(tmpOpenWindow.end_time, timeFormat)]}
                            />
                            <AddButtonBox>
                              <ButtonFormat autoFocus id='CancelButton' design='secondary' onClick={()=>handleCancelButton('openWindow')}>{t('Cancel')}</ButtonFormat>
                              <ButtonFormat autoFocus id='addButton' design='primary' onClick={()=> handleChangeOW('addOpenWindow')}>{t('OK')}</ButtonFormat>
                            </AddButtonBox>
                          </>
                        )}

                        {(modalType==='editOpenWindow') && (
                          <>
                            <AddText htmlFor='' labelText={t('Edit Open Time Window')} />
                            <SelectBox>
                              <SelectField
                                changeCallback={(e)=>handleTmpOpenWindow(e, 'day')}
                                defaultValue='option3'
                                label={{
                                  htmlFor: 'free_select',
                                  text: t('Day Of The Week')
                                }}
                                placeholder={t('Choose an option...')}
                                value={tmpOpenWindow.day_of_week ? tmpOpenWindow.day_of_week : scheduleData[Number(selectedScheduleId)].schedule.open_time_window[Number(selectedButtonId)].day_of_week}
                              >
                                {dayOfWeek.map((item: any, index: any) => {
                                  return (
                                    <option value={item} key={index}>
                                      {t(item)}
                                    </option>
                                  );
                                })}
                                
                              </SelectField>
                            </SelectBox>
                            <TimePicker.RangePicker
                              onPickerValueChange={(e)=> handleTmpOpenWindow(e, 'time')}
                              format={timeFormat}
                              needConfirm={false}
                              value={
                                tmpOpenWindow.start_time ?
                                  [dayjs(tmpOpenWindow.start_time, timeFormat), dayjs(tmpOpenWindow.end_time, timeFormat)]
                                  :
                                  [dayjs(scheduleData[Number(selectedScheduleId)].open_time_window[Number(selectedButtonId)].start_time, timeFormat), dayjs(scheduleData[Number(selectedScheduleId)].open_time_window[Number(selectedButtonId)].end_time, timeFormat)]
                              }
                            />
                            <AddButtonBox>
                              <ButtonFormat autoFocus id='CancelButton' design='secondary' onClick={()=>handleCancelButton('openWindow')}>{t('Cancel')}</ButtonFormat>
                              <ButtonFormat autoFocus id='addButton' design='primary' onClick={()=> handleChangeOW('editOpenWindow')}>{t('OK')}</ButtonFormat>
                            </AddButtonBox>
                          </>
                        )}
                        {(modalType==='addException') && (
                          <>
                            <AddText htmlFor='' labelText={t('Add Exception')} />
                            <DatePicker format={dateFormat} onChange={(e)=> handleTmpException(e, 'day')} />
                            <TimePicker.RangePicker
                              onPickerValueChange={(e)=> handleTmpException(e, 'time')}
                              needConfirm={false}
                              format={timeFormat}
                              value={[dayjs(tmpException.start_time, timeFormat), dayjs(tmpException.end_time, timeFormat)]}
                            />
                            <AddButtonBox>
                              <ButtonFormat autoFocus id='CancelButton' design='secondary' onClick={()=>handleCancelButton('exception')}>{t('Cancel')}</ButtonFormat>
                              <ButtonFormat autoFocus id='addButton' design='primary' onClick={()=> handleChangeException('addException')}>{t('OK')}</ButtonFormat>
                            </AddButtonBox>
                          </>
                        )}

                        {(modalType==='editException') && (
                          <>
                            <AddText htmlFor='' labelText={t('Edit Exception')} />
                            <DatePicker defaultValue={dayjs(tmpException.date, 'MMDD')} format={dateFormat} onChange={(e)=> handleTmpException(e, 'day')} />
                            <TimePicker.RangePicker
                              onPickerValueChange={(e)=> handleTmpException(e, 'time')}
                              needConfirm={false}
                              format={timeFormat}
                              value={
                                tmpException.start_time ?
                                  [dayjs(tmpException.start_time, timeFormat), dayjs(tmpException.end_time, timeFormat)]
                                  :
                                  [dayjs(scheduleData[Number(selectedScheduleId)].open_day[Number(selectedButtonId)].start_time, timeFormat), dayjs(scheduleData[Number(selectedScheduleId)].open_day[Number(selectedButtonId)].end_time, timeFormat)]
                              }
                            />
                            <AddButtonBox>
                              <ButtonFormat autoFocus id='CancelButton' design='secondary' onClick={()=>handleCancelButton('exception')}>{t('Close')}</ButtonFormat>
                              <ButtonFormat autoFocus id='addButton' design='primary' onClick={()=> handleChangeException('editException')}>{t('OK')}</ButtonFormat>
                            </AddButtonBox>
                          </>
                        )}
                      </AddBox>
                    }
                  />}
                <DividerWithMargin />
                <ScheduleContainer>
                  <FlexContainer>
                    <SubTitle>{t('Schedule Exceptions')}</SubTitle>
                    <AddContainer>
                      <ButtonWithIcon
                        icon='Add'
                        position='right'
                        size='small'
                        design='secondary'
                        onClick={handleAddException}
                        disabled={isReadOnly}
                      >
                        {t('Add Exception')}
                      </ButtonWithIcon>
                    </AddContainer>
                    
                  </FlexContainer>
                  <ListButtonContainer>
                    {selectedScheduleId ? scheduleData[Number(selectedScheduleId)].schedule.open_day.map((item: any, index: any) => {
                      return (
                        <TwoButtonContainer key={index} gap='0 2px'>
                          <FilterButton icon='MetaTags' onClick={() => handleEditException(index)}>
                            {dayjs(item.date, 'MMDD').format(t('MM-DD'))} {hideSeconds(item.start_time)} ~ {hideSeconds(item.end_time)}
                          </FilterButton>
                          <ButtonX design='danger' disabled={isReadOnly} onClick={()=> handleRemoveException(index)}>
                            X
                          </ButtonX>
                        </TwoButtonContainer>
                      );
                    }) : ''}
                  </ListButtonContainer>
                </ScheduleContainer>
              </InnerContainer>
            </LineUIContainer>
          )}
        </LineSettingsContainer>
      </MainContent>
    </Content>
  );
};

export default ScheduleConfig;
